import PropTypes from 'prop-types'
import {default as React} from 'react'
import Button from 'react-bootstrap/lib/Button'
import Col from 'react-bootstrap/lib/Col'
import Grid from 'react-bootstrap/lib/Grid'
import Row from 'react-bootstrap/lib/Row'
import {Formik} from '../formik'
import PromoEmailSignupFormContent from './promoEmailSignupFormContent'
import {css} from 'glamor'
import {colors, text} from '../../styles'

const style = {
  text: {
    bodyText: css(text.bodySmall, {
      paddingTop: '7px',
      paddingBotom: '7px'
    })
  },
  dismissButton: css(text.button, {
    color: colors.grayMedium,
    fontSize: '9px',
    fontWeight: '500',
    lineHeight: '10.5px',
    '&:hover': {
      textDecoration: 'underline'
    },
    paddingTop: '20px'
  })
}

const PromoEmailSignupContent = props => {
  if (props.status && props.status.success) {
    return (
      <Grid fluid>
        <Row>
          <h5 {...style.title}>
            <strong>SCORE!</strong>
          </h5>
        </Row>
        <Row>
          <p {...style.text.bodyText}>You’ve successfully subscribed.</p>
        </Row>
        <Row>
          <Col className="text-center">
            <Button
              bsStyle="link"
              {...style.dismissButton}
              onClick={props.hideModalCallback}>
              <p>Dismiss</p>
            </Button>
          </Col>
        </Row>
      </Grid>
    )
  }
  return (
    <form onSubmit={props.handleSubmit} {...style.container}>
      <Grid fluid>
        <Row>
          <PromoEmailSignupFormContent {...props} />
        </Row>
        <Row className="hidden-xs">
          <Col className="text-center">
            <Button
              bsStyle="link"
              {...style.dismissButton}
              onClick={props.hideModalCallback}>
              <p>No Thanks</p>
            </Button>
          </Col>
        </Row>
      </Grid>
    </form>
  )
}

PromoEmailSignupContent.propTypes = {
  errors: PropTypes.shape({
    email: PropTypes.string
  }),
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onFocus: PropTypes.func,
  status: PropTypes.shape({
    success: PropTypes.bool
  }),
  touched: PropTypes.shape({
    email: PropTypes.bool
  }),
  values: PropTypes.shape({
    email: PropTypes.string
  }),
  hideModalCallback: PropTypes.func.isRequired
}

const PromoEmailSignupForm = ({subscribeEmail, hideModalCallback}) => {
  return (
    <Formik
      initialValues={{email: ''}}
      onSubmit={(values, {setStatus, setSubmitting, setErrors}) => {
        subscribeEmail(values.email).then(result => {
          const {
            body: {signUpSuccess = false, errors = []}
          } = result
          if (signUpSuccess) {
            setStatus({
              success: true
            })
          } else if (errors.length !== 0) {
            setSubmitting(false)
            setErrors({
              email: errors[0]
            })
          } else {
            setSubmitting(false)
            setErrors({
              email: 'A network error occurred. Please try again.'
            })
          }
        })
      }}
      render={props => (
        <PromoEmailSignupContent
          {...props}
          hideModalCallback={hideModalCallback}
        />
      )}
    />
  )
}

PromoEmailSignupForm.propTypes = {
  subscribeEmail: PropTypes.func.isRequired,
  hideModalCallback: PropTypes.func.isRequired
}

export default PromoEmailSignupForm
